import React, { useState, useEffect } from "react";
import Select from "react-select";
import axios from "axios";
import { baseurl } from "../../baseurl";
import Swal from "sweetalert2";
import { FiHeart } from "react-icons/fi";
import NavigateHome from "../../component/utils/NavigateHome";
import PageCount from "../../component/utils/PageCount";
import FooterTwo from "../../component/FooterTwo";

 
const Toast = Swal.mixin({
  toast: true,
  position: "top-end",
  showConfirmButton: false,
  timer: 3000,
  timerProgressBar: true,
  customClass: {
    popup: "swal2-toast-custom",   // ⭐ Apply your custom style
  },
});

function ProfileInfo() {
  const [loading, setLoading] = useState(true);

  const [formData, setFormData] = useState({
    highestQualification: "",
    degree: "",
    workSector: "",
    occupation: "",
    annualIncome: "",
  });

  const token = localStorage.getItem("token");

  // 📌 OPTIONS
const highestQualificationOptions = [
  { value: "highschool", label: "High School (10th)" },
  { value: "intermediate", label: "Intermediate (12th)" },
  { value: "diploma", label: "Diploma / ITI / Polytechnic" },
  { value: "graduate", label: "Graduate" },
  { value: "postgraduate", label: "Post Graduate" },
  { value: "phd", label: "PhD / Doctorate" },
  { value: "professional", label: "Professional Degree (CA, CS, etc.)" },
  { value: "other", label: "Other" },
];


 const degreeOptions = [
  // Arts & Commerce
  { value: "ba", label: "B.A" },
  { value: "ma", label: "M.A" },
  { value: "bcom", label: "B.Com" },
  { value: "mcom", label: "M.Com" }, 
  // Science
  { value: "bsc", label: "B.Sc" },
  { value: "msc", label: "M.Sc" }, 
  // Engineering & Tech
  { value: "btech", label: "B.Tech / B.E" },
  { value: "mtech", label: "M.Tech / M.E" }, 
  // Computers
  { value: "bca", label: "BCA" },
  { value: "mca", label: "MCA" }, 
  // Management
  { value: "bba", label: "BBA" },
  { value: "mba", label: "MBA / PGDM" }, 
  // Medical
  { value: "mbbs", label: "MBBS" },
  { value: "bds", label: "BDS" },
  { value: "bams", label: "BAMS" },
  { value: "bhms", label: "BHMS" },
  { value: "md", label: "MD / MS" },
  { value: "nursing", label: "B.Sc Nursing / GNM" }, 
  // Law
  { value: "llb", label: "LLB" },
  { value: "llm", label: "LLM" }, 
  // Architecture
  { value: "barch", label: "B.Arch" },
  { value: "march", label: "M.Arch" }, 
  // Finance & Professional
  { value: "ca", label: "CA (Chartered Accountant)" },
  { value: "cs", label: "CS (Company Secretary)" },
  { value: "cma", label: "CMA (Cost Accountant)" },
  { value: "cfa", label: "CFA" }, 
  // Others
  { value: "phd", label: "PhD" },
  { value: "other", label: "Other" },
];

 const workSectorOptions = [
  { value: "it", label: "IT / Software" },
  { value: "healthcare", label: "Healthcare / Medical" },
  { value: "engineering", label: "Engineering & Manufacturing" },
  { value: "education", label: "Education / Teaching" },
  { value: "business", label: "Business / Entrepreneurship" },
  { value: "government", label: "Government / PSU" },
  { value: "banking", label: "Banking / Finance" },
  { value: "defence", label: "Defence / Police / Forces" },
  { value: "hospitality", label: "Hospitality / Tourism" },
  { value: "media", label: "Media / Entertainment" },
  { value: "realestate", label: "Real Estate / Construction" },
  { value: "transport", label: "Transport / Logistics" },
  { value: "agriculture", label: "Agriculture / Farming" },
  { value: "retail", label: "Retail / Sales" },
  { value: "freelance", label: "Freelance / Remote Work" },
  { value: "other", label: "Other" },
];


  const currentOccupationOptions = [
  // IT & Tech
  { value: "developer", label: "Software Developer" },
  { value: "designer", label: "UI/UX Designer" },
  { value: "product_manager", label: "Product Manager" },
  { value: "data_analyst", label: "Data Analyst / Data Scientist" },
  { value: "qa_engineer", label: "QA / Tester" }, 
  // Management
  { value: "manager", label: "Manager" },
  { value: "team_lead", label: "Team Lead" },
  { value: "executive", label: "Executive" }, 
  // Medical
  { value: "doctor", label: "Doctor" },
  { value: "nurse", label: "Nurse" },
  { value: "pharmacist", label: "Pharmacist" }, 
  // Education
  { value: "teacher", label: "Teacher" },
  { value: "professor", label: "Professor / Lecturer" }, 
  // Business & Finance
  { value: "accountant", label: "Accountant" },
  { value: "finance_analyst", label: "Financial Analyst" }, 
  // Skilled & Technical
  { value: "engineer", label: "Engineer" },
  { value: "electrician", label: "Electrician" },
  { value: "mechanic", label: "Mechanic" }, 
  // Creative
  { value: "artist", label: "Artist" },
  { value: "photographer", label: "Photographer" }, 
  // Self Employment
  { value: "self-employed", label: "Self Employed" },
  { value: "business_owner", label: "Business Owner / Entrepreneur" }, 
  // Others
  { value: "govt_job", label: "Government Job" },
  { value: "not-working", label: "Not Working" },
  { value: "student", label: "Student" },
  { value: "other", label: "Other" },
];


  const annualIncomeOptions = [
    { value: "0-2", label: "₹0 – ₹2 Lakhs" },
    { value: "2-5", label: "₹2 – ₹5 Lakhs" },
    { value: "5-10", label: "₹5 – ₹10 Lakhs" },
    { value: "10-20", label: "₹10 – ₹20 Lakhs" },
    { value: "20-50", label: "₹20 – ₹50 Lakhs" },
    { value: "50+", label: "₹50 Lakhs+" },
  ];

  // 🔹 Convert backend value → react-select format
  const getOption = (options, value) =>
    options.find((opt) => opt.value === value) || null;

  // 🚀 FETCH PROFESSIONAL DETAILS
  useEffect(() => {
    const fetchProfessionalData = async () => {
      try {
        const response = await axios.get(`${baseurl}getUserProfessionalDetails`, {
          headers: { Authorization: `Bearer ${token}` },
        });

        const data = response.data.additional_details;

        setFormData({
          highestQualification: data.highest_qualification || "",
          degree: data.degree || "",
          workSector: data.work_sector || "",
          occupation: data.current_occupation || "",
          annualIncome: data.annual_income || "",
        });
      } catch (err) {
        console.error("Error fetching professional details:", err);
      }

      setLoading(false);
    };

    fetchProfessionalData();
  }, []);

  // CHANGE HANDLERS
  const handleSelectChange = (field, value) => {
    setFormData((prev) => ({ ...prev, [field]: value }));
  };

  // SUBMIT UPDATE
 const handleSubmit = async (e) => {
  e.preventDefault();

  try {
    const response = await axios.post(
      `${baseurl}updateUserProfessionalDetails`,
      {
        highest_qualification: formData.highestQualification,
        degree: formData.degree,
        work_sector: formData.workSector,
        current_occupation: formData.occupation,
        annual_income: formData.annualIncome,
      },
      {
        headers: { Authorization: `Bearer ${token}` },
      }
    );

    Toast.fire({
      icon: "success",
      title: "Professional details updated successfully!",
    });

    console.log("Update response:", response.data);

    // ⬇️ Redirect after a short delay
    setTimeout(() => {
      window.location.href = "/religion-detail";
    }, 800);

  } catch (err) {
    console.error("Update error:", err);

    Toast.fire({
      icon: "error",
      title: err?.response?.data?.error || "Failed to update",
    });
  }
};


  if (loading) return <p>Loading...</p>;

  return (
    <>
    
    <section className="profileinfo-section">
      <PageCount pageName = {"user Profile Info"}/>
      <NavigateHome/>
      <div className="profileinfo-container"> 
        {/* <h2 className="text-center mb-4">Professional Information</h2> */}

        <div className="basicinfo-header text-center mb-4">
                  <FiHeart className="header-icon" />
                  <h2>Professional Information</h2>
                  <p>
                    Let’s begin your journey with <b>Soulsathi.com</b> ❤️
                  </p>
                </div>

        <form className="profileinfo-form" onSubmit={handleSubmit}>
          <div className="row g-3">

            <div className="col-md-6">
              <label>Highest Qualification</label>
              <Select
                options={highestQualificationOptions} classNamePrefix="talaash-select"
                value={getOption(highestQualificationOptions, formData.highestQualification)}
                placeholder="Select highest qualification"
                onChange={(v) => handleSelectChange("highestQualification", v.value)}
              />
            </div>

            <div className="col-md-6">
              <label>Degree</label>
              <Select
                options={degreeOptions} classNamePrefix="talaash-select"
                value={getOption(degreeOptions, formData.degree)}
                placeholder="Select degree"
                onChange={(v) => handleSelectChange("degree", v.value)}
              />
            </div>

            <div className="col-md-6">
              <label>Work Sector</label>
              <Select
                options={workSectorOptions} classNamePrefix="talaash-select"
                value={getOption(workSectorOptions, formData.workSector)}
                placeholder="Select sector"
                onChange={(v) => handleSelectChange("workSector", v.value)}
              />
            </div>

            <div className="col-md-6">
              <label>Current Occupation</label>
              <Select
                options={currentOccupationOptions} classNamePrefix="talaash-select"
                value={getOption(currentOccupationOptions, formData.occupation)}
                placeholder="Select occupation"
                onChange={(v) => handleSelectChange("occupation", v.value)}
              />
            </div>

            <div className="col-md-6">
              <label>Annual Income</label>
              <Select
                options={annualIncomeOptions} classNamePrefix="talaash-select"
                value={getOption(annualIncomeOptions, formData.annualIncome)}
                placeholder="Income range"
                onChange={(v) => handleSelectChange("annualIncome", v.value)}
              />
            </div>

          </div>

          <div className="text-center mt-4">
            <button type="submit" className="btn-primary">
              Save & Continue →
            </button>
          </div>
        </form>
      </div>
    </section>

    <FooterTwo />

    </>
  );
}

export default ProfileInfo;
